export interface IMangoEventAnalyticsConfig {
  type: MangoEventAnalyticsType;
  key: string;
}

export enum MangoEventAnalyticsType {
  GOOGLE_ANALYTICS = 'google-analytics',
  TAG_MANAGER = 'tag-manager',
}
